export const DISABLE_CURSOR = 'not-allowed';
